import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Gamer from '../../../../assets/images/loading/Gamer.svg';
import Loader from '../../../../components/Loader';
import { commonAssets, mapGameToStaticResources } from '../../helpers';
import usePreloader from '../../../scene/hooks/usePreloader';
import { useAppSelector } from '../../../../core/redux/hooks/useAppSelector';
import { selectGameType } from '../../selectors';

import styles from './styles.module.scss';

const PreloadContainer: React.FC = () => {
  const navigate = useNavigate();
  const gameType = useAppSelector(selectGameType);

  const { progress, isLoaded } = usePreloader({
    images: gameType ? [...commonAssets.images, ...mapGameToStaticResources[gameType].images] : [],
    audios: gameType ? [...commonAssets.audio, ...mapGameToStaticResources[gameType].audio] : [],
  });

  useEffect(() => {
    if (isLoaded) {
      navigate(`/${gameType}/difficulty`);
    }
  }, [isLoaded, progress, navigate, gameType]);

  return (
    <div className={styles.container}>
      <img src={Gamer} className={styles.gamer} alt="Gamer" />
      <Loader progress={progress} />
    </div>
  );
};

export default PreloadContainer;
